

<div id="loader">
  <!-- <p>Selection chart is Loading....</p> -->
  <!-- <img src="assets/images/loadingCursor.gif"/> -->
  <div class="loader"></div>
</div>


